import React from "react";


function Header() {
    return (
        <header>
            <h1>My Task <i class="fas fa-pen-fancy"></i></h1>
        </header>
    );
}

export default Header; 
